<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-modal v-model="modalActive" width="50%" scroll="clip" style="z-index: 101" @close="clearFields()">
      <div class="modal-card" style="width: auto; height: 80vh">
        <header class="modal-card-head" style="padding: 12px">
          <h6 class="is-size-5 ml-auto mr-auto pl-4 has-text-weight-semibold">
            {{ mode === 'siteMove' ? 'Move Traffic Site' : mode === 'rework' ? 'Create Rework Site Plan' : 'Create Bulk Rework Site Plans' }}</h6>
          <button
              type="button"
              class="delete"
              @click="show(false, deselectOnClose)"/>
        </header>
        <div class="has-background-light">
          <b-field class="m-3">
            <b-input
                placeholder="Search..."
                type="search"
                icon="magnify"
                v-model="searchQuery"
            ></b-input>
          </b-field>
        </div>
        <section class="modal-card-body p-0">

          <div>
            <div class="m-5">
              <b-field v-for="project in projects" :key="project._id">
                <b-radio v-model="projectChoice"
                         :native-value="project">
                  {{ project.name }}
                </b-radio>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="padding: 0">
          <b-button v-if="mode === 'siteMove'" class="is-primary is-fullwidth m-2" @click="onMove" rounded
                    :disabled="projectChoice === null">
            Move Site
          </b-button>
          <b-button v-else-if="mode === 'rework'" class="is-primary is-fullwidth m-2" @click="onRework" rounded
                    :disabled="projectChoice === null">
            Create Rework Site Plan
          </b-button>
          <b-button v-else-if="mode === 'rework_multiple'" class="is-primary is-fullwidth m-2" @click="onReworkMultiple" rounded
                    :disabled="projectChoice === null">
            Create Bulk Rework Site Plans
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "move-site-modal",
  data() {
    return {
      isLoading: false,
      modalActive: false,
      deselectOnClose: false,
      projectChoice: null,
      siteToMove: null,
      mode: 'siteMove',
      projectSitePlanId: null,
      reworkSitePlanIds: [],
      searchQuery: ''
    }
  },
  methods: {
    ...mapActions({
      moveTrafficSite: 'projectsModule/moveTrafficSite',
      createReworkSitePlan: 'projectsModule/createReworkSitePlan',
    }),
    async onMove() {
      console.log('On move site: ', this.siteToMove)
      let payload = {
        siteId: this.siteToMove.siteId,
        projectId: this.projectChoice._id,
        oldProjectId: this.selectedProject._id
      }

      console.log('On move site payload: ', payload)

      this.isLoading = true
      let response = await this.moveTrafficSite(payload)
      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        this.showToast(`Traffic Site successfully moved to project with name "${this.projectChoice.name}"`, 'is-success')
        await this.clearFields()
        this.show(false)
      }
      this.isLoading = false
    },
    async onRework() {
      console.log('On move site: ', this.siteToMove)
      let payload = {
        oldSitePlanId: this.projectSitePlanId,
        newProjectId: this.projectChoice._id
      }

      console.log('On create rework: ', payload)

      this.isLoading = true
      let response = await this.createReworkSitePlan(payload)
      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {

        this.showToast(`Rework Site Plan successfully created for project with name "${this.projectChoice.name}"`, 'is-success')
        await this.clearFields()
        this.show(false)
      }
      this.isLoading = false
    },
    async onReworkMultiple(){
      if(this.reworkSitePlanIds && this.reworkSitePlanIds.length > 0){
        let errorMessages = []
        for (let i = 0; i < this.reworkSitePlanIds.length; i++) {

          console.log('Creating multiple rework site plans, plan id: ', this.reworkSitePlanIds[0])
          let payload = {
            oldSitePlanId: this.reworkSitePlanIds[i],
            newProjectId: this.projectChoice._id
          }

          this.isLoading = true
          let response = await this.createReworkSitePlan(payload)
          if (response instanceof Error) {
            errorMessages.push(response.message)
          } else {
            this.showToast(`Rework Site Plan successfully created for project with name "${this.projectChoice.name}"`, 'is-success')
          }
          this.isLoading = false
        }

        if(errorMessages.length > 0){
          this.$buefy.snackbar.open({
            message: errorMessages.toString(),
            type: "is-danger",
            position: "is-top",
            actionText: "Ok",
            indefinite: true,
            onAction: () => {
            },
          });
        }

        await this.clearFields()
        this.show(false)
      }
    },
    show(show, deselectOnClose, site) {
      this.mode = 'siteMove'
      this.siteToMove = site
      console.log('Site to move', site)
      this.modalActive = show
      this.deselectOnClose = deselectOnClose
      if (!this.modalActive) {
        this.clearFields()
      }
    },
    showRework(show, deselectOnClose, projectSitePlanId) {
      this.mode = 'rework'
      this.projectSitePlanId = projectSitePlanId
      this.modalActive = show
      this.deselectOnClose = deselectOnClose
      if (!this.modalActive) {
        this.clearFields()
      }
    },
    showReworkMultiple(show, deselectOnClose, reworkPlanIds) {
      this.mode = 'rework_multiple'
      this.reworkSitePlanIds = reworkPlanIds
      this.modalActive = show
      this.deselectOnClose = deselectOnClose
      if (!this.modalActive) {
        this.clearFields()
      }
    },
    async clearFields() {
      this.projectChoice = null
      this.siteToMove = null
      this.projectSitePlanId = null
      this.reworkSitePlanIds = []
      this.mode = 'siteMove'
      this.searchQuery = ''
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 5000,
        type: type
      })
    }
  },
  computed: {
    ...mapGetters({
      allProjects: 'projectsModule/getAllProjects',
      selectedProject: 'projectsModule/getSelectedProject'
    }),
    projects() {
      let projects = []
      this.allProjects.forEach(project => {
        if (project._id !== this.selectedProject._id && project.name.toLowerCase().includes(this.searchQuery.toLowerCase())) {
          projects.push(project)
        }
      })

/*      if (!this.searchQuery) return this.projects
      const query = this.searchQuery.toLowerCase()
      return this.projects.filter(p =>
          p.name.toLowerCase().includes(query)
      )*/

      return projects
    }
  }
}
</script>

<style scoped>

</style>